import FragmentPage from '../core/FragmentPage';

export default class Covid19Page extends FragmentPage {
  constructor(meta) {
    super('covid19', meta);
  }
}
